var _ = require('lodash')

// global
var Settings = {
  author: 'Dpt',
  name: 'Momenta',
  id: 'momenta_vue',
  cookies: {
    lang: 'momenta_vue_lang',
    sound: 'momenta_vue_sound'
  },
  locale: ['fr', 'en'],
  // activer ou non le smoothscroll
  smoothScroll: true,
  loader: true,
  // can be 'out-in', 'in-out' or ''
  mode: '',
  // prefix les routes avec les lang disponible
  // ex : fr/accueil
  prefixRoute: false,
  // Si vue est utiliser avec un CMS (craft ou wordpress)
  cms: true,
  // Si electron/cordova ou local server,
  localAssets: false,
  // build le projet dans ce path, si electron ou cordova changer ici
  dist: {
    root: '../dist',
    subfolder: ''
  },
  // api
  API_PREFIX: 'wp-json/acf/v3',
  ADMIN_PREFIX: 'cms'
}

// dev
if((process.env.NODE_ENV !== 'production'))
{
  // Settings['BASE_URL'] = 'http://gom.momentabiennale.com'
  // Settings['BASE_URL'] = 'http://enki.momentabiennale.com'
  Settings['BASE_URL'] = 'https://momenta-v2.dpt.media' 
}
// production
else
{
  Settings['BASE_URL'] = ''
}

if(typeof(window) !== 'undefined') {
  // disable loader for prerender.io
  if (/PhantomJS/.test(window.navigator.userAgent))
    Settings.loader = false

  // OVERWRITE BY PHP ENV
  if(typeof(window) !== 'undefined' && window.__ENV !== undefined)
    Settings = _.merge(Settings, window.__ENV)
}

// concat BASE_URL + PREFIX
Settings['API_URL'] = Settings.BASE_URL + '/' + Settings.API_PREFIX + '/'


module.exports = Settings




// WEBPACK FOOTER //
// ./src/config/Settings.js